__turbopack_context__.v({
  "card": "CustomImage-module-scss-module__MSluoG__card",
  "image": "CustomImage-module-scss-module__MSluoG__image",
  "is-loading": "CustomImage-module-scss-module__MSluoG__is-loading",
  "shine": "CustomImage-module-scss-module__MSluoG__shine",
});
